import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b751f6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "AppHeader__Navbar" }
const _hoisted_2 = { class: "BtnInformation" }

import { computed, unref, withDefaults } from 'vue'
import { useI18n } from 'vue-i18n'
import { useActor } from '@xstate/vue'
import AppService from '@/store/states/AppService'
import { AppStateEnum } from '@/store/states/AppStateMachine'
import informationPanel from '@/store/modules/InformationPanel'
import legalPage from '@/store/modules/LegalPage'
import Viewport from '@/store/modules/Viewport'

import LocaleChanger from '@/components/LocaleChanger/LocaleChanger.vue'
import UIBtnGallery from '@/components/UIBtn/UIBtnGallery.vue'
import UIAudioBtn from '@/components/UIAudioBtn/UIAudioBtn.vue'
import Gtm from '@/utils/Gtm'

interface Props {
  theme?: THEME
}


import { defineComponent } from 'vue'

export const enum THEME {
  LIGHT = 'light',
  DARK = 'dark'
}

const __default__ = defineComponent({})

function setup(__props: any) {

const props = __props as { theme: THEME }



const { t } = useI18n()
const { state, send } = useActor(AppService)

const closeLabel = computed(() => {
  const currentState = unref(state)
  if (currentState.matches(AppStateEnum.SHARE)) {
    return t('common.back_to_painting')
  }
  if (currentState.matches(AppStateEnum.GALLERY)) {
    if( currentState.context.galleryReferer === 'museum' ) {
      return t('common.back_to_museum')
    }
    return t('common.back_to_painting')
  }
})


const showLocaleChanger = computed(() => {
  return !legalPage.isOpen && 
    state.value.matches(AppStateEnum.HOME)
})

const showAboutBtn = computed(() => {
  return !informationPanel.isOpen && 
    !legalPage.isOpen && 
    [
      AppStateEnum.HOME,
      AppStateEnum.MUSEUM,
    ].some(state.value.matches)
})

const showCloseBtn = computed(() => {
  return informationPanel.isOpen || 
    legalPage.isOpen || 
    [
      AppStateEnum.SHARE,
      AppStateEnum.GALLERY,
    ].some(state.value.matches)
})

const showGalleryButton = computed(() => {
  const whitelist = [
    `${AppStateEnum.PAINTING}.explore`,
    `${AppStateEnum.PAINTING}.photo.tutorial`,
  ]

  if (Viewport.isDesktop) {
    whitelist.push( AppStateEnum.MUSEUM)
  }
  return whitelist.some(state.value.matches)
})

const showAudioBtn = computed(() => !Viewport.isDesktop && ![
  AppStateEnum.HOME,
].some(state.value.matches))

const showBrandLogo = computed(() => ![
  `${AppStateEnum.PAINTING}.explore`,
].some(state.value.matches))


function onGalleryClick() {
  send('GOTO_GALLERY')
  Gtm.sendEventPush(
    'header',
    'go-to-photo-gallery',
    'Click on See photo from other'
  )
}

function doClose() {
  const currentState = unref(state)
  if (legalPage.isOpen) {
    return legalPage.close()
  }
  if (informationPanel.isOpen) {
    return informationPanel.close()
  }
  if (currentState.matches(AppStateEnum.SHARE)) {
    Gtm.sendEventPush(
      'header',
      'back-to-painting',
      'Click on Back to painting'
    )
    return send('CANCEL')
  }
  if (currentState.matches(AppStateEnum.GALLERY)) {
    if( currentState.context.galleryReferer === 'museum' ) {
      return send('GOTO_MUSEUM')
    }
    
    Gtm.sendEventPush(
      'header',
      'back-to-painting',
      'Click on Back to painting'
    )
    return send('GOTO_PAINTING')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_ui_icon = _resolveComponent("ui-icon")!
  const _component_ui_btn_round = _resolveComponent("ui-btn-round")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["AppHeader z-ui", `AppHeader--${__props.theme}`])
  }, [
    _withDirectives(_createElementVNode("button", {
      class: "AppHeader__Logo",
      type: "button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(send)('GOTO_HOME')))
    }, [
      _createVNode(_component_ui_icon, {
        class: "AppHeader__Brand",
        name: "logo-nationalgalerie"
      })
    ], 512), [
      [_vShow, _unref(showBrandLogo)]
    ]),
    _createElementVNode("div", _hoisted_1, [
      (_unref(showLocaleChanger))
        ? (_openBlock(), _createBlock(LocaleChanger, { key: 0 }))
        : _createCommentVNode("", true),
      (_unref(showAudioBtn))
        ? (_openBlock(), _createBlock(UIAudioBtn, {
            key: 1,
            theme: __props.theme
          }, null, 8, ["theme"]))
        : _createCommentVNode("", true),
      (_unref(showGalleryButton))
        ? (_openBlock(), _createBlock(UIBtnGallery, {
            key: 2,
            onClick: onGalleryClick
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createVNode(_component_ui_btn_round, {
          type: "button",
          class: "AppHeader__Close",
          active: true,
          onClick: doClose
        }, _createSlots({
          default: _withCtx(() => [
            _createVNode(_component_ui_icon, { name: "close" })
          ]),
          _: 2
        }, [
          (_unref(closeLabel))
            ? {
                name: "label",
                fn: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(closeLabel)), 1)
                ])
              }
            : undefined
        ]), 1536), [
          [_vShow, _unref(showCloseBtn)]
        ]),
        _withDirectives(_createVNode(_component_ui_btn_round, {
          type: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(informationPanel).open()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ui_icon, { name: "info" })
          ]),
          _: 1
        }, 512), [
          [_vShow, _unref(showAboutBtn)]
        ])
      ])
    ])
  ], 2))
}
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    theme: { default: THEME.LIGHT }
  },
  setup})